import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.3/Types.js";
import { OutboundMsg_$reflection as OutboundMsg_$reflection_1, InboundMsg_$reflection as InboundMsg_$reflection_1, LocalMsg_$reflection as LocalMsg_$reflection_1, Model_$reflection as Model_$reflection_1 } from "../../../FileManagement/FileManagementTypes.js";
import { OutboundMsg_$reflection as OutboundMsg_$reflection_2, InboundMsg_$reflection as InboundMsg_$reflection_2, LocalMsg_$reflection as LocalMsg_$reflection_2, Model_$reflection as Model_$reflection_2 } from "../../../FileManagement/FileUploadSelectors/DragDropFileSelector/DragDropTypes.js";
import { union_type, class_type, record_type } from "../../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Msg$3_$reflection } from "../../../Common/InboundOutbound.js";

export class Model extends Record {
    constructor(fileUpload, dragDrop) {
        super();
        this.fileUpload = fileUpload;
        this.dragDrop = dragDrop;
    }
}

export function Model_$reflection() {
    return record_type("RAWMap.Client.Study.AnalysisForm.AnalysisFile.Types.Model", [], Model, () => [["fileUpload", Model_$reflection_1()], ["dragDrop", Model_$reflection_2()]]);
}

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExceptionError", "ClearChildrenLists", "FileManagementMsg", "DragDropMsg"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("RAWMap.Client.Study.AnalysisForm.AnalysisFile.Types.LocalMsg", [], LocalMsg, () => [[["Item", class_type("System.Exception")]], [], [["Item", Msg$3_$reflection(LocalMsg_$reflection_1(), InboundMsg_$reflection_1(), OutboundMsg_$reflection_1())]], [["Item", Msg$3_$reflection(LocalMsg_$reflection_2(), InboundMsg_$reflection_2(), OutboundMsg_$reflection_2())]]]);
}

export class OutboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DownloadableFilesUpdated", "StartedZipping", "UploadStarted", "UploadCompleted", "UploadFailed", "FileDeleted"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("RAWMap.Client.Study.AnalysisForm.AnalysisFile.Types.OutboundMsg", [], OutboundMsg, () => [[], [], [], [], [], []]);
}

export class InboundMsg extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["RefreshFileList"];
    }
}

export function InboundMsg_$reflection() {
    return union_type("RAWMap.Client.Study.AnalysisForm.AnalysisFile.Types.InboundMsg", [], InboundMsg, () => [[]]);
}

